require("./m-pagination.scss");


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/molecule/m-pagination/m-pagination.chunk.js